import axios from 'axios';
// import qs from 'qs'

/**
 * POST 方法 与 GET方法  区别
 *
 * post==> data: obj
 * get==>params: obj
 *
 */
// 例如(post)：
//登录
export function login(data) {
  return axios({
    url: '/login', // url = base url + request url
    method: 'POST',
    data: data, //----------------->>>区别
  });
}

// 智慧校园系统登录
export function hdAccess(data) {
  return axios({
    url: '/hdAccess', // url = base url + request url
    method: 'POST',
    data: data, //----------------->>>区别
  });
}

//根据手机号 获取学校
export function getTeacherSchools(params) {
  return axios({
    url: '/getTeacherSchools', // url = base url + request url
    method: 'get',
    params: params,
  });
}

//获取所有角色列表
export function getAllRoleList(params) {
  return axios({
    url: '/role/getAllRoleList', // url = base url + request url
    method: 'get',
    params: params,
  });
}

// 添加角色
export function addSchoolRole(data) {
  return axios({
    url: '/school/schoolRole/addSchoolRole', // url = base url + request url
    method: 'post',
    data: data,
  });
}

//编辑角色
export function updateSchoolRole(data) {
  return axios({
    url: '/school/schoolRole/updateSchoolRole', // url = base url + request url
    method: 'post',
    data: data,
  });
}

// 删除角色
export function delSchoolRole(data) {
  return axios({
    url: '/school/schoolRole/delSchoolRole', // url = base url + request url
    method: 'post',
    data: data,
  });
}

// 批量删除角色
export function batchDelSchoolRole(data) {
  return axios({
    url: '/school/schoolRole/batchDelSchoolRole', // url = base url + request url
    method: 'post',
    data: data,
  });
}

// 根据角色id获取菜单选中状态
export function getSchoolRoleMenuList(params) {
  let id = params.id;
  return axios({
    url: '/school/schoolRole/getSchoolRoleMenuList', // url = base url + request url
    method: 'get',
    params: { id: id },
  });
}

//修改学校角色菜单权限
export function updateSchoolRoleMenuList(data) {
  return axios({
    url: '/school/schoolRole/updateSchoolRoleMenuList', // url = base url + request url
    method: 'post',
    data: data,
  });
}

//获取所有部门列表
export function getAllDepartList(params) {
  return axios({
    url: '/depart/getAllDepartList', // url = base url + request url
    method: 'get',
    params: params,
  });
}

//增加部门
export function addDepart(data) {
  return axios({
    url: '/depart/addDepart', // url = base url + request url
    method: 'post',
    data: data,
  });
}

//修改部门
export function updateDepart(data) {
  return axios({
    url: '/depart/updateDepart', // url = base url + request url
    method: 'post',
    data: data,
  });
}

// 删除/禁用部门
export function deleteDepart(data) {
  return axios({
    url: '/depart/deleteDepart', // url = base url + request url
    method: 'post',
    data: data,
  });
}

// 给部门批量导入教师
export function departmentBatchImportTeacher(data) {
  return axios({
    url: '/depart/departmentBatchImportTeacher', // url = base url + request url
    method: 'post',
    data: data,
  });
}

// 根据部门获取教师的选中状态
export function getDepartmentTeacherList(params) {
  return axios({
    url: '/depart/getDepartmentTeacherList', // url = base url + request url
    method: 'get',
    params: params,
  });
}

//根据部门id获取教师列表
export function getAllDepartTeachers(params) {
  return axios({
    url: '/depart/getAllDepartTeachers', // url = base url + request url
    method: 'get',
    params: params,
  });
}

// 给部门批量添加教师
export function departmentBatchAddTeacher(data) {
  return axios({
    url: '/depart/departmentBatchAddTeacher', // url = base url + request url
    method: 'post',
    data: data,
  });
}

// 添加教师
export function addSchoolTeacher(data) {
  return axios({
    url: '/school/teacher/addSchoolTeacher', // url = base url + request url
    method: 'post',
    data: data,
  });
}

// 更改教师
export function updateSchoolTeacher(data) {
  return axios({
    url: '/school/teacher/updateSchoolTeacher', // url = base url + request url
    method: 'post',
    data: data,
  });
}

// 删除教师
export function delSchoolTeacher(data) {
  return axios({
    url: '/school/teacher/delSchoolTeacher', // url = base url + request url
    method: 'post',
    data: data,
  });
}

// 批量删除教师
export function batchDelSchoolTeacher(data) {
  return axios({
    url: '/school/teacher/batchDelSchoolTeacher', // url = base url + request url
    method: 'post',
    data: data,
  });
}

//获取本学校角色列表
export function getSchoolRoleList(params) {
  return axios({
    url: '/school/schoolRole/getSchoolRoleList', // url = base url + request url
    method: 'get',
    params: params,
  });
}

//新增岗位
// export function addStation(data) {
//   return axios({
//     url: '/station/addStation', // url = base url + request url
//     method: 'post',
//     data: data
//   })
// }
//
// //更改岗位
// export function updateStation(data) {
//   return axios({
//     url: '/station/updateStation', // url = base url + request url
//     method: 'post',
//     data: data
//   })
// }

//删除岗位
export function deleteStation(data) {
  return axios({
    url: '/station/deleteStation', // url = base url + request url
    method: 'post',
    data: data,
  });
}

//添加学生
export function saveStudent(data) {
  return axios({
    url: '/student/saveStudent', // url = base url + request url
    method: 'post',
    data: data,
  });
}

// 更改学生
export function updateStudent(data) {
  return axios({
    url: '/student/updateStudent', // url = base url + request url
    method: 'post',
    data: data,
  });
}

// 删除学生
export function deleteStudent(data) {
  return axios({
    url: '/student/deleteStudent', // url = base url + request url
    method: 'post',
    data: data,
  });
}

//批量删除学生
export function deleteStudents(data) {
  return axios({
    url: '/student/deleteStudents', // url = base url + request url
    method: 'post',
    data: data,
  });
}

//获取当前学校指定教师的所有班级列表
export function finiteDataTree(params) {
  return axios({
    url: '/student/finiteDataTree', // url = base url + request url
    method: 'get',
    params: params,
  });
}

//添加工作组
export function addGroup(data) {
  return axios({
    url: '/group/addGroup', // url = base url + request url
    method: 'post',
    data: data,
  });
}

//更改工作组
export function updateGroup(data) {
  return axios({
    url: '/group/updateGroup', // url = base url + request url
    method: 'post',
    data: data,
  });
}

//删除工作组
export function deleteGroup(data) {
  return axios({
    url: '/group/deleteGroup', // url = base url + request url
    method: 'post',
    data: data,
  });
}

//删除工作组内的老师
export function deleteGroupTeacher(data) {
  return axios({
    url: '/group/deleteGroupTeacher', // url = base url + request url
    method: 'post',
    data: data,
  });
}

//获取所有部门以及所有老师 该工作组的勾选状态
export function getGroupTeacherChecked(params) {
  return axios({
    url: '/group/getGroupTeacherChecked', // url = base url + request url
    method: 'get',
    params: params,
  });
}

//更新工作组包含的教师列表
export function groupUpdateTeacher(data) {
  return axios({
    url: '/group/groupUpdateTeacher', // url = base url + request url
    method: 'post',
    data: data,
  });
}

//获取老师自己的所有工作组列表
export function getTeacherAllGroup(params) {
  return axios({
    url: '/group/getTeacherAllGroup', // url = base url + request url
    method: 'get',
    params: params,
  });
}

//给老师身上绑定班级设置职位新
export function addTeacherStations(data) {
  return axios({
    url: '/station/addTeacherStations', // url = base url + request url
    method: 'post',
    data: data,
  });
}

//删除老师身上职位
export function delTeacherPosition(data) {
  return axios({
    url: '/station/delTeacherPosition', // url = base url + request url
    method: 'post',
    data: data,
  });
}

//获取学校所有的班级树
export function getAllClassTree(params) {
  return axios({
    url: '/station/getAllClassTree', // url = base url + request url
    method: 'get',
    params: params,
  });
}

//获取学校所有的年级树
export function getAllGradeTree(params) {
  return axios({
    url: '/station/getAllGradeTree', // url = base url + request url
    method: 'get',
    params: params,
  });
}

//获取学生家长手机号
export function getParentsByStudentId(params) {
  return axios({
    url: '/parent/getParentsByStudentId', // url = base url + request url
    method: 'get',
    params: params,
  });
}

//新增学生手机号
export function saveParentsByStudentId(data) {
  return axios({
    url: '/parent/saveParentsByStudentId', // url = base url + request url
    method: 'post',
    data: data,
  });
}

// 更改学生家长手机号
export function updateParent(data) {
  return axios({
    url: '/parent/updateParent', // url = base url + request url
    method: 'post',
    data: data,
  });
}

//正常/停用/删除 学生家长手机号信息
export function deleteParentIds(data) {
  return axios({
    url: '/parent/deleteParentIds', // url = base url + request url
    method: 'post',
    data: data,
  });
}

//按角色发送短信（学校管理员）
export function sendMessageByRole(data) {
  return axios({
    url: '/school/schoolMessage/sendMessageByRole', // url = base url + request url
    method: 'post',
    data: data,
  });
}

//按部门发送短信（学校管理员）
export function sendMessageByDepartment(data) {
  return axios({
    url: '/school/schoolMessage/sendMessageByDepartment', // url = base url + request url
    method: 'post',
    data: data,
  });
}

//按工作组发送短信（学校管理员+教师）
export function sendMessageByGroup(data) {
  return axios({
    url: '/school/schoolMessage/sendMessageByGroup', // url = base url + request url
    method: 'post',
    data: data,
  });
}

//给指定教师发送短信（学校管理员+教师）
export function sendMessageByTeacher(data) {
  return axios({
    url: '/school/schoolMessage/sendMessageByTeacher', // url = base url + request url
    method: 'post',
    data: data,
  });
}

//按负责班级发送短信(教师)
export function sendMessageByClass(data) {
  return axios({
    url: '/school/schoolMessage/sendMessageByClass', // url = base url + request url
    method: 'post',
    data: data,
  });
}

//获取指定学校的指定教师的班级学生树
export function getStudentTreeByClassId(params) {
  return axios({
    url: '/student/getStudentTreeByClassId', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

//指定学生发送短信（教师）
export function sendMessageByStudent(data) {
  return axios({
    url: '/school/schoolMessage/sendMessageByStudent', // url = base url + request url
    method: 'post',
    data: data,
  });
}

//根据部门id获取老师
export function getTeacherListByDepartmentId(params) {
  return axios({
    url: '/depart/getTeacherListByDepartmentId', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

//获取指定教师负责的班级
export function getSchoolClassByTeacher(data) {
  return axios({
    url: '/school/teacher/getSchoolClassByTeacher', // url = base url + request url
    method: 'post',
    data: data,
  });
}

//发送邮件
export function sendEmail(data) {
  return axios({
    url: '/email/sendEmail', // url = base url + request url
    method: 'post',
    data: data,
  });
}

// 保存草稿箱
export function saveEmail(data) {
  return axios({
    url: '/email/saveEmail', // url = base url + request url
    method: 'post',
    data: data,
  });
}

// 草稿箱发送邮件
export function sendDraftEmail(data) {
  return axios({
    url: '/email/sendDraftEmail', // url = base url + request url
    method: 'post',
    data: data,
  });
}

//上传文件
export function getFilePath(data) {
  return axios({
    url: '/file/getFilePath', // url = base url + request url
    method: 'post',
    data: data,
  });
}

//获取邮件详情
export function getEmailInfo(params) {
  return axios({
    url: '/email/getEmailInfo', // url = base url + request url
    method: 'GET',
    params: params,
  });
}
//==================================行为
//删除行为
export function deleteBehavior(data) {
  return axios({
    url: '/school/behavior/deleteBehavior', // url = base url + request url
    method: 'POST',
    data: data,
  });
}
//删除行为
export function delById(data) {
  return axios({
    url: '/school/behavior/delById', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

//更新行为
export function updateBehavior(data) {
  return axios({
    url: '/school/behavior/updateBehavior', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

//添加行为
export function saveBehavior(data) {
  return axios({
    url: '/school/behavior/saveBehavior', // url = base url + request url
    method: 'POST',
    data: data,
  });
}
//获取学校行为列表
export function getSchoolBehavior(params) {
  return axios({
    url: '/school/behavior/getSchoolBehavior', // url = base url + request url
    method: 'GET',
    params: params,
  });
}
//获取班级行为数据
export function getStudentBehaviorByClassId(params) {
  return axios({
    url: '/school/behavior/getStudentBehaviorByClassId', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 导出本班学生行为分值详情
export function exportStudentBehaviorByClassId(params) {
  return axios({
    url: '/school/behavior/exportStudentBehaviorByClassId', // url = base url + request url
    method: 'GET',
    responseType: 'blob',
    params: params,
  });
}

//获取指定学校的所有班级列表
export function getAllBGCDataBySchoolId(params) {
  return axios({
    url: '/student/getAllBGCDataBySchoolId', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 导入学生考试成绩
export function importStudentExamExcel(data) {
  return axios({
    url: '/school/exam/importStudentExamExcel', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

//修改某一次考试名称
export function alterStudentExamExcel(data) {
  return axios({
    url: '/school/exam/alterStudentExamExcel', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

//删除某一次考试录入
export function deleteExamByIds(data) {
  return axios({
    url: '/school/exam/deleteExamByIds', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

//展示成绩详情
export function examInfoById(params) {
  return axios({
    url: '/school/exam/examInfoById', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

//发送成绩短信
export function examSendSMS(data) {
  return axios({
    url: '/school/exam/examSendSMS', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

//获取科目
export function examSubInfoById(params) {
  return axios({
    url: '/school/exam/examSubInfoById', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

//分页展示班级代码接口
export function findClassCodeByGradeId(params) {
  return axios({
    url: '/student/exam/findClassCodeByGradeId', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 导出失物招领记录列表
export function exportSchoolLostList(params) {
  return axios({
    url: '/school/lost/exportSchoolLostList', // url = base url + request url
    method: 'GET',
    responseType: 'blob',
    params: params,
  });
}

//发送教师短信
export function sendTeacherAccountMessage(data) {
  return axios({
    url: '/school/teacher/sendTeacherAccountMessage', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 添加请假审核人和班级
export function saveAuditTeacherAndClassScope(data) {
  return axios({
    url: '/school/studentLeave/saveAuditTeacherAndClassScope', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 添加请假值班人和班级
export function saveLeaveTeacherClassScope(data) {
  return axios({
    url: '/school/studentLeave/saveLeaveTeacherClassScope', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 删除请假审核人和班级
export function deleteAuditTeacherAndClassScope(data) {
  return axios({
    url: '/school/studentLeave/deleteAuditTeacherAndClassScope', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 删除请假值班人和班级
export function deleteLeaveTeacherClassScope(data) {
  return axios({
    url: '/school/studentLeave/deleteLeaveTeacherClassScope', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 按条件查询请假审核人和班级
export function findAuditTeacherAndClassScopeByCondition(params) {
  return axios({
    url: '/school/studentLeave/findAuditTeacherAndClassScopeByCondition', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 按条件查询请假值班人和班级
export function findLeaveTeacherAndClassScopeByCondition(params) {
  return axios({
    url: '/school/studentLeave/findLeaveTeacherAndClassScopeByCondition', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

//获取学校总的请假数据报表
export function getLeaveReport(params) {
  return axios({
    url: '/leaveReport/getLeaveReport', // url = base url + request url
    method: 'GET',
    // responseType:'blob',
    params: params,
  });
}

// 设置学校到校离校时间
export function setSchoolArriveLeaveTime(data) {
  return axios({
    url: '/school/studentLeave/setSchoolArriveLeaveTime', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 查询本学校定义的时间段
export function findSchoolArriveLeaveTime(params) {
  return axios({
    url: '/school/studentLeave/findSchoolArriveLeaveTime', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 增加新闻
export function addNews(data) {
  return axios({
    url: '/school/news/addNews', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 修改新闻
export function updateNews(data) {
  return axios({
    url: '/school/news/updateNews', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 删除新闻
export function updateState(data) {
  return axios({
    url: '/school/news/updateState', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

//新增本学校静默时间段
export function saveSchoolSilentTime(data) {
  return axios({
    url: '/school/silent/saveSchoolSilentTime', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

//修改本学校静默时间段
export function alterSchoolSilentTime(data) {
  return axios({
    url: '/school/silent/alterSchoolSilentTime', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

//删除本学校静默时间段
export function deleteSchoolSilentTime(data) {
  return axios({
    url: '/school/silent/deleteSchoolSilentTime', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 增加自定义巡查项目
export function addScope(data) {
  return axios({
    url: '/school/schoolSearch/addScope', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 修改自定义巡查项目
export function updateScope(data) {
  return axios({
    url: '/school/schoolSearch/updateScope', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 删除自定义巡查项目
export function delScope(data) {
  return axios({
    url: '/school/schoolSearch/delScope', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 增加查询范围
export function addRange(data) {
  return axios({
    url: '/school/schoolSearch/addRange', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 修改查询范围
export function updateRange(data) {
  return axios({
    url: '/school/schoolSearch/updateRange', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 删除查询范围
export function delRange(data) {
  return axios({
    url: '/school/schoolSearch/delRange', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 根据自定义巡查id获取查询范围的树状图
export function getRangeList(params) {
  return axios({
    url: '/school/schoolSearch/getRangeList', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 获取学校所有的自定义查询范围详情页
export function getInfoAllRange(params) {
  return axios({
    url: '/school/schoolSearch/getInfoAllRange', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 获取学校所有的自定义巡查项目
export function getAllScope(params) {
  return axios({
    url: '/school/schoolSearch/getAllScope', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 增加结果设置
export function addSearchResult(data) {
  return axios({
    url: '/school/schoolSearch/addSearchResult', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 修改结果设置
export function updateSearchResult(data) {
  return axios({
    url: '/school/schoolSearch/updateSearchResult', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 删除结果设置
export function delSearchResult(data) {
  return axios({
    url: '/school/schoolSearch/delSearchResult', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 获取巡查结果列表excel
export function getSearchInfoExcel(params) {
  return axios({
    url: '/school/schoolSearch/getSearchInfoExcel', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 获取学校所有的自定义巡查项目详情页
export function getInfoAllScope(params) {
  return axios({
    url: '/school/schoolSearch/getInfoAllScope', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 获取学校所有的自定义结果详情页
export function getInfoAllResult(params) {
  return axios({
    url: '/school/schoolSearch/getInfoAllResult', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 增加意见反馈
export function addProblem(data) {
  return axios({
    url: '/school/problem/addProblem', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

//导出学生考勤记录
export function getAllClockingListExcel(params) {
  return axios({
    url: '/school/clock/getAllClockingListExcel', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

//导出教师考勤记录
export function getAllTeacherClockingListExcel(params) {
  return axios({
    url: '/school/clock/getAllTeacherClockingListExcel', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 修改教师手机号
export function updateTeacherMobile(data) {
  return axios({
    url: '/school/teacher/updateTeacherMobile', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 修改教师密码
export function updateTeacherPassword(data) {
  return axios({
    url: '/school/teacher/updateTeacherPassword', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 添加宿舍结构
export function addDormitoryStructure(data) {
  return axios({
    url: '/school/dormitory/addDormitoryStructure', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 修改宿舍结构
export function updateDormitoryStructure(data) {
  return axios({
    url: '/school/dormitory/updateDormitoryStructure', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 删除宿舍结构
export function deleteDormitoryStructure(data) {
  return axios({
    url: '/school/dormitory/deleteDormitoryStructure', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 获取宿舍树形结构
export function getDormitoryStructureTree(params) {
  return axios({
    url: '/school/dormitory/getDormitoryStructureTree', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 给学生分配宿舍
export function studentAssignedDormitoryRoom(data) {
  return axios({
    url: '/school/dormitory/studentAssignedDormitoryRoom', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 给老师分配宿舍
export function teacherAssignedDormitoryRoom(data) {
  return axios({
    url: '/school/dormitory/teacherAssignedDormitoryRoom', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 将学生移除宿舍
export function studentRemoveDormitoryRoom(data) {
  return axios({
    url: '/school/dormitory/studentRemoveDormitoryRoom', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 获取教师登录学校的学生树
export function getStudentTreeByDormitoryState(params) {
  return axios({
    url: '/school/dormitory/getStudentTreeByDormitoryState', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 根据年级导出统计体温记录
export function exportTemperatureRecordByGrade(params) {
  return axios({
    url: '/school/temperature/exportTemperatureRecordByGrade', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 查询学校的体温阈值
export function getTemperatureThresholdBySchool(params) {
  return axios({
    url: '/school/temperature/getTemperatureThresholdBySchool', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 设置学校的体温阈值
export function setTemperatureThreshold(data) {
  return axios({
    url: '/school/temperature/setTemperatureThreshold', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 根据年级获取异常体温学生列表
export function getAbnormalTemperatureStudentListByGrade(params) {
  return axios({
    url: '/school/temperature/getAbnormalTemperatureStudentListByGrade', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 根据年级获取未上报体温学生列表
export function getUnreportTemperatureStudentListByGrade(params) {
  return axios({
    url: '/school/temperature/getUnreportTemperatureStudentListByGrade', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

//导出异常学生名册详情
export function exportStudentCheckRollDetails(params) {
  return axios({
    url: '/studentCheckRoll/exportStudentCheckRollDetails', // url = base url + request url
    method: 'GET',
    responseType: 'blob',
    params: params,
  });
}

// 获取年级中学生已点名册异常详情
export function getStudentCheckRollDetailsById(params) {
  return axios({
    url: '/studentCheckRoll/getStudentCheckRollDetailsById', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 获取年级中班级已点名册详情
export function getClasssCheckRollById(params) {
  return axios({
    url: '/studentCheckRoll/getClasssCheckRollById', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 根据学生ID修改学生班级(平台调班)
export function changeStudentClass(data) {
  return axios({
    url: '/student/changeStudentClass', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 添加清空在宿时间
export function addDormitoryClearTime(data) {
  return axios({
    url: '/dormitoryClearTime/addDormitoryClearTime', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 删除清空在宿时间
export function deleteDormitoryClearTime(data) {
  return axios({
    url: '/dormitoryClearTime/deleteDormitoryClearTime', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 修改清空在宿时间
export function updateDormitoryClearTime(data) {
  return axios({
    url: '/dormitoryClearTime/updateDormitoryClearTime', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 获取教师考勤内容列表
export function getTeacherAttendanceList(params) {
  return axios({
    url: '/teacherAttendance/getTeacherAttendanceList', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 设置教师考勤内容
export function setTeacherAttendance(data) {
  return axios({
    url: '/teacherAttendance/setTeacherAttendance', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 修改教师考勤内容
export function updateTeacherAttendance(data) {
  return axios({
    url: '/teacherAttendance/updateTeacherAttendance', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

//删除教师考勤内容
export function deleteTeacherAttendance(data) {
  return axios({
    url: '/teacherAttendance/deleteTeacherAttendance', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 获取教师考勤统计
export function getTeacherAttendanceRecordBySchool(params) {
  return axios({
    url: '/teacherAttendance/getTeacherAttendanceRecordBySchool', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 根据学校导出教师考勤统计
export function exportTeacherAttendanceRecordBySchool(params) {
  return axios({
    url: '/teacherAttendance/exportTeacherAttendanceRecordBySchool', // url = base url + request url
    method: 'GET',
    params: params,
    responseType: 'blob',
  });
}

// 获取学校班级名称
export function findBranchTreeNameByClassId(params) {
  return axios({
    url: '/student/findBranchTreeNameByClassId', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

//增加教师考勤组
export function addTeacherAttendanceGroup(data) {
  return axios({
    url: '/hwTeacherAttendance/addTeacherAttendanceGroup', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

//修改教师考勤组
export function updateTeacherAttendanceGroup(data) {
  return axios({
    url: '/hwTeacherAttendance/updateTeacherAttendanceGroup', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

//删除教师考勤组
export function deleteTeacherAttendanceGroup(data) {
  return axios({
    url: '/hwTeacherAttendance/deleteTeacherAttendanceGroup', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 根据考勤组教师考勤统计
export function getTeacherAttendanceRecordByAttendanceGroup(params) {
  return axios({
    url: '/hwTeacherAttendance/getTeacherAttendanceRecordByAttendanceGroup', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 根据考勤组获取教师考勤内容列表
export function getTeacherAttendanceListByGroup(params) {
  return axios({
    url: '/teacherAttendance/getTeacherAttendanceListByGroup', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 根据考勤组设置教师考勤内容
export function setTeacherAttendanceByGroup(data) {
  return axios({
    url: '/teacherAttendance/setTeacherAttendanceByGroup', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 根据考勤组获取教师考勤内容列表
export function exportTeacherAttendanceRecordByAttendanceGroup(params) {
  return axios({
    url: '/hwTeacherAttendance/exportTeacherAttendanceRecordByAttendanceGroup', // url = base url + request url
    method: 'GET',
    params: params,
    responseType: 'blob',
  });
}

// 手动添加教师考勤刷脸
export function addTeacherAttendanceSlotFace(data) {
  return axios({
    url: '/hwTeacherAttendance/addTeacherAttendanceSlotFace', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 手动添加教师考勤刷脸
export function batchAddDormitoryRoom(data) {
  return axios({
    url: '/school/dormitory/batchAddDormitoryRoom', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 获取宿舍楼层树形结构
export function getDormitoryStoreyStructureTree(params) {
  return axios({
    url: '/school/dormitory/getDormitoryStoreyStructureTree', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 检查单录入school:educationExamine:saveInformBill
export function saveInformBill(data) {
  return axios({
    url: '/educationExamine/saveInformBill', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 违纪原因列表school:educationExamine:getItemLists
export function getItemLists(params) {
  return axios({
    url: '/educationExamine/getItemLists', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 分值列表school:educationExamine:getItemScoreList
export function getItemScoreList(params) {
  return axios({
    url: '/educationExamine/getItemScoreList', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 常规添加school:educationExamine:saveGeneral
export function saveGeneral(data) {
  return axios({
    url: '/educationExamine/saveGeneral', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 常规删除school:educationExamine:deleteGeneralByIds
export function deleteGeneralByIds(data) {
  return axios({
    url: '/educationExamine/deleteGeneralByIds', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 项目列表school:educationExamine:getItemListById
export function getItemListById(params) {
  return axios({
    url: '/educationExamine/getItemListById', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 项目添加school:educationExamine:saveItem
export function saveItem(data) {
  return axios({
    url: '/educationExamine/saveItem', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 项目删除school:educationExamine:deleteItemByIds
export function deleteItemByIds(data) {
  return axios({
    url: '/educationExamine/deleteItemByIds', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 新增分值school:educationExamine:saveScore
export function saveScore(data) {
  return axios({
    url: '/educationExamine/saveScore', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 删除分值school:educationExamine:deleteScoreByIdS
export function deleteScoreByIdS(data) {
  return axios({
    url: '/educationExamine/deleteScoreByIdS', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 每日一览（默认当天日期查询）school:educationExamine:getGeneralItemScoreByDate
export function getGeneralItemScoreByDate(params) {
  return axios({
    url: '/educationExamine/getGeneralItemScoreByDate', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 检查通知单详情school:educationExamine:showItemBillsByClassIdDate
export function showItemBillsByClassIdDate(params) {
  return axios({
    url: '/educationExamine/showItemBillsByClassIdDate', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 删除检查通知单school:educationExamine:deleteItemBillsByIds
export function deleteItemBillsByIds(data) {
  return axios({
    url: '/educationExamine/deleteItemBillsByIds', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 短信发送 school:educationExamine:sendEducationExamineBill
export function sendEducationExamineBill(data) {
  return axios({
    url: '/educationExamine/sendEducationExamineBill', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 按日期统计（默认起始截止都是当天日期）school:educationExamine:getClassGeneralItemStatisticsByDate
export function getClassGeneralItemStatisticsByDate(params) {
  return axios({
    url: '/educationExamine/getClassGeneralItemStatisticsByDate', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 按日期导出（默认起始截止都是当天日期）school:educationExamine:exportClassGeneralItemStatisticsByDate
export function exportClassGeneralItemStatisticsByDate(params) {
  return axios({
    url: '/educationExamine/exportClassGeneralItemStatisticsByDate', // url = base url + request url
    method: 'GET',
    params: params,
    responseType: 'blob',
  });
}

// 项目修改school:educationExamine:updateItem
export function updateItem(data) {
  return axios({
    url: '/educationExamine/updateItem', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 常规修改school:educationExamine:updateGeneral
export function updateGeneral(data) {
  return axios({
    url: '/educationExamine/updateGeneral', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 设置班级宣言(school:slogan:setClassSlogan)
export function setClassSlogan(data) {
  return axios({
    url: '/slogan/setClassSlogan', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 获取学校课程节次列表(school:course:getCourseSectionList)
export function getCourseSectionList(params) {
  return axios({
    url: '/course/getCourseSectionList', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 设置学校课程节次(school:course:setCourseSection)
export function setCourseSection(data) {
  return axios({
    url: '/course/setCourseSection', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 新增课程(school:course:addCourse)
export function addCourse(data) {
  return axios({
    url: '/course/addCourse', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 修改课程(school:course:updateCourse)
export function updateCourse(data) {
  return axios({
    url: '/course/updateCourse', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 添加班牌(school:billboard:addBillboard)
export function addBillboard(data) {
  return axios({
    url: '/billboard/addBillboard', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 删除班牌(school:billboard:deleteBillboard)
export function deleteBillboard(data) {
  return axios({
    url: '/billboard/deleteBillboard', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 获取学校欢迎内容(school:billboard:getSchoolGreet)
export function getSchoolGreet(params) {
  return axios({
    url: '/billboard/getSchoolGreet', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 获取学校通知(school:billboard:getSchoolNotice)
export function getSchoolNotice(params) {
  return axios({
    url: '/billboard/getSchoolNotice', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 获取班牌显示模式(school:billboard:getBillboardType)
export function getBillboardType(params) {
  return axios({
    url: '/billboard/getBillboardType', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 获取班级考试信息(school:billboard:getClassExam)
export function getClassExam(params) {
  return axios({
    url: '/billboard/getClassExam', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 设置学校欢迎内容(school:billboard:setSchoolGreet)
export function setSchoolGreet(data) {
  return axios({
    url: '/billboard/setSchoolGreet', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 设置学校通知(school:billboard:setSchoolNotice)
export function setSchoolNotice(data) {
  return axios({
    url: '/billboard/setSchoolNotice', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 设置班牌显示模式(school:billboard:updateBillboardType)
export function updateBillboardType(data) {
  return axios({
    url: '/billboard/updateBillboardType', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 设置班级考试信息(school:billboard:setClassExam)
export function setClassExam(data) {
  return axios({
    url: '/billboard/setClassExam', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 展示学生迎新短信(school:newStudent:showNewStudentSMS)
export function showNewStudentSMS(params) {
  return axios({
    url: '/school/newStudent/showNewStudentSMS', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 发送学生迎新短信(school:newStudent:sendNewStudentSMS)
export function sendNewStudentSMS(params) {
  return axios({
    url: '/school/newStudent/sendNewStudentSMS', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 导入学生迎新模板(school:newStudent:importNewStudentExcel)
export function importNewStudentExcel(data) {
  return axios({
    url: '/school/newStudent/importNewStudentExcel', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 删除学生迎新模板(school:newStudent:deleteNewStudenteTemplate)
export function deleteNewStudenteTemplate(params) {
  return axios({
    url: '/school/newStudent/deleteNewStudenteTemplate', // url = base url + request url
    method: 'GET',
    params: params,
  });
}

// 新增问卷(school:survey:addSurvey)
export function addSurvey(data) {
  return axios({
    url: '/survey/addSurvey', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 新增问卷条目(school:survey:addEntries)
export function addEntries(data, surveyid) {
  return axios({
    url: '/survey/addEntries?surveyid=' + surveyid, // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 获取问卷表单(school:survey:fetchSurveyForm)
export function fetchSurveyForm(params) {
  return axios({
    url: '/survey/fetchSurveyForm',
    method: 'GET',
    params: params,
  });
}

// 设置问卷状态(school:survey:changeSurveyStatus)
export function changeSurveyStatus(params) {
  return axios({
    url: '/survey/changeSurveyStatus',
    method: 'GET',
    params: params,
  });
}

// 获取调查问卷详情
export function surveyUserDetail(id) {
  return axios({
    url: '/survey/userDetail/' + id,
    method: 'GET',
  });
}

// 导出问卷信息
export function surveyExport(id) {
  return axios({
    url: '/survey/export/' + id,
    method: 'GET',
    responseType: 'blob',
  });
}

// 删除问卷
export function delSurvey(params) {
  return axios({
    url: '/survey/del',
    method: 'GET',
    params: params,
  });
}

// 考勤组删除教师(school:hwTeacherAttendance:delTeacherByAttendanceGroup)
export function delTeacherByAttendanceGroup(data) {
  return axios({
    url: '/hwTeacherAttendance/delTeacherByAttendanceGroup', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 考勤组添加教师（school:hwTeacherAttendance:addTeacherByAttendanceGroup）
export function addTeacherByAttendanceGroup(data) {
  return axios({
    url: '/hwTeacherAttendance/addTeacherByAttendanceGroup', // url = base url + request url
    method: 'POST',
    data: data,
  });
}

// 考勤组已添加教师ID(school:hwTeacherAttendance:findTeacherByAttendanceId)
export function findTeacherByAttendanceId(params) {
  return axios({
    url: '/hwTeacherAttendance/findTeacherByAttendanceId',
    method: 'GET',
    params: params,
  });
}

// 登录校园消费web平台 school:xskweb:loginConsumeSystem
export function loginConsumeSystem(params) {
  return axios({
    url: '/xskweb/loginConsumeSystem',
    method: 'GET',
    params: params,
  });
}

// 登录校园电话web平台 school:xskweb:loginPhoneSystem
export function loginPhoneSystem(params) {
  return axios({
    url: '/xskweb/loginPhoneSystem',
    method: 'GET',
    params: params,
  });
}

// 登录互动学生卡web平台 school:xskweb:loginXSKSystem
export function loginXSKSystem(params) {
  return axios({
    url: '/xskweb/loginXSKSystem',
    method: 'GET',
    params: params,
  });
}

// 获取考勤时间段接口
export function getAttendanceList(params) {
  return axios({
    url: '/zj/getAttendanceList',
    method: 'GET',
    params: params,
  });
}

// 设置考勤时间段接口
export function setAttendanceList(data) {
  return axios({
    url: '/zj/setAttendanceList',
    method: 'POST',
    data: data,
  });
}

// 修改考勤时间段接口
export function updateAttendanceList(data) {
  return axios({
    url: '/zj/updateAttendanceList',
    method: 'POST',
    data: data,
  });
}

// 删除考勤时间段接口
export function delAttendanceList(params) {
  return axios({
    url: '/zj/delAttendanceList',
    method: 'GET',
    params: params,
  });
}

// 添加审核组
export function saveCheckGroup(data) {
  return axios({
    url: '/teacherLeave/saveCheckGroup',
    method: 'POST',
    data: data,
  });
}
// 修改审核组
export function updateCheckGroup(data) {
  return axios({
    url: '/teacherLeave/updateCheckGroup',
    method: 'POST',
    data: data,
  });
}
// 删除审核组
export function deleteCheckGroup(data) {
  return axios({
    url: '/teacherLeave/deleteCheckGroup',
    method: 'POST',
    data: data,
  });
}

// 本学校设置审核级别（school:teacherLeave:findSchoolArriveLeaveTime）
export function schoolLeaveLevelSet(data) {
  return axios({
    url: '/teacherLeave/schoolLeaveLevelSet',
    method: 'POST',
    data: data,
  });
}

// 展示学校设置审核级别（school:teacherLeave:getSchoolLeaveLevel）
export function getSchoolLeaveLevel(params) {
  return axios({
    url: '/teacherLeave/getSchoolLeaveLevel',
    method: 'GET',
    params: params,
  });
}

// 添加审核组教师
export function saveCheckGroupTeacher(data) {
  return axios({
    url: '/teacherLeave/saveCheckGroupTeacher',
    method: 'POST',
    data: data,
  });
}

// 删除审核组教师
export function deleteCheckGroupTeacher(data) {
  return axios({
    url: '/teacherLeave/deleteCheckGroupTeacher',
    method: 'POST',
    data: data,
  });
}

// 添加审核组被审核教师（school:teacherLeave:saveGroupAuditedTeacher）
export function saveGroupAuditedTeacher(data) {
  return axios({
    url: '/teacherLeave/saveGroupAuditedTeacher',
    method: 'POST',
    data: data,
  });
}

// 删除审核组被审核教师（school:teacherLeave:deleteGroupAuditedTeacher）
export function deleteGroupAuditedTeacher(data) {
  return axios({
    url: '/teacherLeave/deleteGroupAuditedTeacher',
    method: 'POST',
    data: data,
  });
}

// 导出教师请假详情(school:teacherLeave:exportTeacherLeaveInfo)
export function exportTeacherLeaveInfo(params) {
  return axios({
    url: '/teacherLeave/exportTeacherLeaveInfo',
    method: 'GET',
    params: params,
    responseType: 'blob',
  });
}

// 添加审核组与（创建）审核教师组关联（school:teacherLeave:saveCheckGroupTeacherAndLevelC）
export function updateLevelGroup(data) {
  return axios({
    url: '/teacherLeave/updateLevelGroup',
    method: 'POST',
    data: data,
  });
}

// 修改审核组与（创建）审核教师组关联（school:teacherLeave:updateLevelGroup）
export function saveCheckGroupTeacherAndLevelC(data) {
  return axios({
    url: '/teacherLeave/saveCheckGroupTeacherAndLevelC',
    method: 'POST',
    data: data,
  });
}

// 删除审核组与审核教师组关联（school:teacherLeave:deleteCheckGroupTeacherAndLevel）
export function deleteCheckGroupTeacherAndLevel(data) {
  return axios({
    url: '/teacherLeave/deleteCheckGroupTeacherAndLevel',
    method: 'POST',
    data: data,
  });
}

// 展示审核组被审核教师（school:teacherLeave:showGroupAuditedTeacher）
export function showGroupAuditedTeacher(params) {
  return axios({
    url: '/teacherLeave/showGroupAuditedTeacher',
    method: 'GET',
    params: params,
  });
}

// 新增修改物品（school:repair:goods:save）
export function saveGoods(data) {
  return axios({
    url: '/school/repair/goods/save',
    method: 'POST',
    data: data,
  });
}

// 删除物品（school:repair:goods:del）
export function delGoods(id) {
  return axios({
    url: '/school/repair/goods/del/' + id,
    method: 'GET',
  });
}

// 导出维修记录（school:repair:export）
export function exportRepair(params) {
  return axios({
    url: '/school/repair/export',
    method: 'GET',
    params: params,
    responseType: 'blob',
  });
}

// 新增修改分配(school:hs:allocation)
export function saveAllocation(data) {
  return axios({
    url: '/school/hs/allocation',
    method: 'POST',
    data: data,
  });
}

// 删除分配(school:hs:remove)
export function removeAllocation(id) {
  return axios({
    url: '/school/hs/remove/' + id,
    method: 'POST',
  });
}

// 获取学校核酸状态(school:hs:getHsState)
export function getHsState(params) {
  return axios({
    url: '/school/hs/getHsState',
    method: 'GET',
    params: params,
  });
}

// 学校核酸状态开关(school:hs:open)
export function openHsState(data) {
  return axios({
    url: '/school/hs/open',
    method: 'POST',
    data: data,
  });
}

// 获取问卷调查详情（school:survey:detail）
export function getSurveyDetail(params) {
  return axios({
    url: '/survey/detail',
    method: 'GET',
    params: params,
  });
}

// 修改问卷(school:survey:updateSurvey)
export function updateSurvey(data) {
  return axios({
    url: '/survey/updateSurvey',
    method: 'POST',
    data: data,
  });
}

// 获取学校短信信息（school:schoolMessage:getMessageData）
export function getMessageData(params) {
  return axios({
    url: '/school/schoolMessage/getMessageData',
    method: 'GET',
    params: params,
  });
}

// 检查单记录school:educationExamine:examineList
export function examineList(params) {
  return axios({
    url: '/educationExamine/examineList',
    method: 'GET',
    params: params,
  });
}

// 违纪原因列表一级school:educationExamine:getItemListFirst
export function getItemListFirst(params) {
  return axios({
    url: '/educationExamine/getItemListFirst',
    method: 'GET',
    params: params,
  });
}
// 检查单班级下拉选school:educationExamine:classListByGradeId
export function classListByGradeId(params) {
  return axios({
    url: '/educationExamine/classListByGradeId',
    method: 'GET',
    params: params,
  });
}

// 删除检查单记录school:educationExamine:del
export function delExamineRecord(data) {
  return axios({
    url: '/educationExamine/del',
    method: 'POST',
    data: data,
  });
}

// 检查单记录-导出school:educationExamine:examineListExport
export function examineListExport(params) {
  return axios({
    url: '/educationExamine/examineListExport',
    method: 'GET',
    params: params,
    responseType: 'blob',
  });
}

// 检查单修改school:educationExamine:updateInformBill
export function updateInformBill(data) {
  return axios({
    url: '/educationExamine/updateInformBill',
    method: 'POST',
    data: data,
  });
}

// 批量选择教师给角色(school:schoolRole:roleBatchTeacherList)
export function roleBatchTeacherList(data) {
  return axios({
    url: '/school/schoolRole/roleBatchTeacherList',
    method: 'POST',
    data: data,
  });
}

// 获取所有部门下的所有老师 树-角色(school:depart:getAllDepartTeachersRole)
export function getAllDepartTeachersRole(params) {
  return axios({
    url: '/depart/getAllDepartTeachersRole',
    method: 'GET',
    params: params,
  });
}

// 编辑宿舍床号信息
export function updateBedNumberById(data) {
  return axios({
    url: '/school/dormitory/updateBedNumberById',
    method: 'POST',
    data: data,
  });
}

// 获取指标大类列表
export function getDormitoryAssessCategory(params) {
  return axios({
    url: '/school/dormitory/getDormitoryAssessCategory',
    method: 'GET',
    params: params,
  });
}

// 设置宿舍量化考评指标大类
export function addDormitoryAssessCategory(data) {
  return axios({
    url: '/school/dormitory/addDormitoryAssessCategory',
    method: 'POST',
    data: data,
  });
}

// 获取指标列表
export function getDormitoryAssessItem(params) {
  return axios({
    url: '/school/dormitory/getDormitoryAssessItem',
    method: 'GET',
    params: params,
  });
}

// 设置宿舍量化考评指标
export function addDormitoryAssessItem(data) {
  return axios({
    url: '/school/dormitory/addDormitoryAssessItem',
    method: 'POST',
    data: data,
  });
}

// 宿舍量化汇总
export function getDormitoryAssessReport(params) {
  return axios({
    url: '/school/report/getDormitoryAssessReport',
    method: 'GET',
    params: params,
  });
}

// 获取班级量化考核指标
export function getClassAssessItemList(params) {
  return axios({
    url: '/school/classAssess/getClassAssessItemList',
    method: 'GET',
    params: params,
  });
}

// 班级量化指标设置
export function addClassAssessItem(data) {
  return axios({
    url: '/school/classAssess/addClassAssessItem',
    method: 'POST',
    data: data,
  });
}

// 获取班级量化汇总
export function getClassQuantizeAggregate(params) {
  return axios({
    url: '/school/report/getClassQuantizeAggregate',
    method: 'GET',
    params: params,
  });
}
// 获取班级量化考评结果
export function getClassAssessReport(params) {
  return axios({
    url: '/school/report/getClassAssessReport',
    method: 'GET',
    params: params,
  });
}

// 更新宿舍量化考评指标大类(school:dormitory:updateDormitoryAssessCategory)
export function updateDormitoryAssessCategory(data) {
  return axios({
    url: '/school/dormitory/updateDormitoryAssessCategory',
    method: 'POST',
    data: data,
  });
}

// 更新宿舍量化考评指标(school:dormitory:updateDormitoryAssessItem)
export function updateDormitoryAssessItem(data) {
  return axios({
    url: '/school/dormitory/updateDormitoryAssessItem',
    method: 'POST',
    data: data,
  });
}

// 删除宿舍量化考评指标大类(school:dormitory:deleteDormitoryAssessCategory)
export function deleteDormitoryAssessCategory(data) {
  return axios({
    url: '/school/dormitory/deleteDormitoryAssessCategory',
    method: 'POST',
    data: data,
  });
}

// 删除宿舍量化考评指标(school:dormitory:deleteDormitoryAssessItem)
export function deleteDormitoryAssessItem(data) {
  return axios({
    url: '/school/dormitory/deleteDormitoryAssessItem',
    method: 'POST',
    data: data,
  });
}

// 更新班级量化考评指标(school:classAssess:updateClassAssessItem)
export function updateClassAssessItem(data) {
  return axios({
    url: '/school/classAssess/updateClassAssessItem',
    method: 'POST',
    data: data,
  });
}
// 删除班级量化考评指标(school:classAssess:deleteClassAssessItem)
export function deleteClassAssessItem(data) {
  return axios({
    url: '/school/classAssess/deleteClassAssessItem',
    method: 'POST',
    data: data,
  });
}
// 获取学校请假审核等级（school:studentLeave:saveAuditTeacherAndClassScope）
export function getSchoolAuditLevel(data) {
  return axios({
    url: '/school/studentLeave/getSchoolAuditLevel',
    method: 'POST',
    data: data,
  });
}
// 学生个人行为评价列表-查询学生(school:behavior:getStudentBehaviorList)
export function getStudent(params) {
  return axios({
    url: '/school/behavior/getStudent',
    method: 'GET',
    params: params,
  });
}
// 学生个人行为评价列表(school:behavior:getStudentBehaviorList)
export function getStudentBehaviorList(params) {
  return axios({
    url: '/school/behavior/getStudentBehaviorList',
    method: 'GET',
    params: params,
  });
}
// 学生个人行为评价列表-删除(school:behavior:updateBehaviorEvaluationItem)
export function delBehaviorEvaluationItem(params) {
  return axios({
    url: '/school/behavior/delBehaviorEvaluationItem',
    method: 'GET',
    params: params,
  });
}
// 学生个人行为评价列表-学生行为列表(school:behavior:updateBehaviorEvaluationItem)
export function studentBehaviorList(params) {
  return axios({
    url: '/school/behavior/studentBehaviorList',
    method: 'GET',
    params: params,
  });
}

// 学生个人行为评价列表-修改(school:behavior:updateBehaviorEvaluationItem)
export function updateBehaviorEvaluationItem(data) {
  return axios({
    url: '/school/behavior/updateBehaviorEvaluationItem',
    method: 'POST',
    data: data,
  });
}
// 学生个人行为评价列表-导出(school:behavior:getStudentBehaviorList)
export function studentBehaviorExport(params) {
  return axios({
    url: '/school/behavior/studentBehaviorExport',
    method: 'GET',
    responseType: 'blob',
    params: params,
  });
}
// 班级宿舍量化查询(school:dormitory:getDormitoryScoreList)
export function getDormitoryScoreList(params) {
  return axios({
    url: '/school/dormitory/getDormitoryScoreList',
    method: 'GET',
    params: params,
  });
}
// 班级宿舍量化查询-导出(school:dormitory:getDormitoryScoreList)
export function dormitoryScoreExport(params) {
  return axios({
    url: '/school/dormitory/dormitoryScoreExport',
    method: 'GET',
    responseType: 'blob',
    params: params,
  });
}
// 班级综合评价汇总列表-导出(school:behavior:compositeExport)
export function compositeExport(params) {
  return axios({
    url: '/school/behavior/compositeExport',
    method: 'GET',
    responseType: 'blob',
    params: params,
  });
}
// 班级综合评价汇总列表(school:behavior:compositeList)
export function compositeList(params) {
  return axios({
    url: '/school/behavior/compositeList',
    method: 'GET',
    params: params,
  });
}
// 删除定时短信（school:schoolMessage:delTimingMessage）
export function delTimingMessage(data) {
  return axios({
    url: '/school/schoolMessage/delTimingMessage',
    method: 'POST',
    data: data,
  });
}
// 班级综合评价汇总列表-班级详情列表-导出(school:behavior:classCompositeExport)
export function classCompositeExport(params) {
  return axios({
    url: '/school/behavior/classCompositeExport',
    method: 'GET',
    responseType: 'blob',
    params: params,
  });
}
// 班级综合评价汇总列表-班级详情列表-整体导出(school:behavior:classCompositeExport)
export function classCompositeAllExport(params) {
  return axios({
    url: '/school/behavior/classCompositeAllExport',
    method: 'GET',
    responseType: 'blob',
    params: params,
  });
}

// 发送家长账号短信
export function sendAccountMsg(params) {
  return axios({
    url: '/parent/sendAccountMsg',
    method: 'GET',
    params: params,
  });
}
// 全部宿舍得分导出
export function dormitoryTotalScoreExport(params) {
  return axios({
    url: '/school/behavior/dormitoryTotalScoreExport',
    method: 'GET',
    responseType: 'blob',
    params: params,
  });
}

export function compositeChart(params) {
  return axios({
    url: '/school/behavior/compositeChart',
    method: 'GET',
    params: params,
  });
}

// 分页获取录取结果列表(school:admission:getList)
export function getAdmissionResultList(params) {
  return axios({
    url: '/admission/getList',
    method: 'GET',
    params: params,
  });
}

// 导入录取结果(school:admission:import)
export function importAdmissionResult(data) {
  return axios({
    url: '/admission/import',
    method: 'POST',
    data: data,
  });
}

// 录取结果修改添加(school:admission:saveData)
export function saveAdmissionResult(data) {
  return axios({
    url: '/admission/saveData',
    method: 'POST',
    data: data,
  });
}

// 录取结果删除(school:admission:delData)
export function delAdmissionResult(data) {
  return axios({
    url: '/admission/delData',
    method: 'POST',
    data: data,
  });
}

// 家长录取结果查询
export function searchAdmissionResult(params) {
  return axios({
    url: '/admission/parentSearch',
    method: 'GET',
    params: params,
  });
}

// 录取结果发送验证码
export function sendMessageAdmission(params) {
  return axios({
    url: '/admission/sendMessage',
    method: 'GET',
    params: params,
  });
}

//录取验证码验证
export function verifyAdmission(params) {
  return axios({
    url: '/admission/verify',
    method: 'GET',
    params: params,
  });
}

// 获取录取通知书配置（school:admission:saveConfig）
export function getAdmissionConfig(params) {
  return axios({
    url: '/admission/getConfig',
    method: 'GET',
    params: params,
  });
}

// 保存录取通知书配置(school:admission:saveConfig)
export function saveAdmissionConfig(data) {
  return axios({
    url: '/admission/saveConfig',
    method: 'POST',
    data: data,
  });
}

// 查询学生宿舍信息
export function getStudentDormitoryRoomData(params) {
  return axios({
    url: '/school/dormitory/getStudentDormitoryRoomData',
    method: 'GET',
    params: params,
  });
}

// 补签
export function addDormitorySign(data) {
  return axios({
    url: '/school/dormitory/sign/addDormitorySign',
    method: 'POST',
    data: data,
  });
}

// 宿舍下拉选
export function towerSelect(params) {
  return axios({
    url: '/school/dormitory/sign/towerSelect',
    method: 'GET',
    params: params,
  });
}

// 考勤数据导出
export function studentSignExport(params) {
  return axios({
    url: '/school/dormitory/sign/studentSignExport',
    method: 'GET',
    params: params,
    responseType: 'blob',
  });
}

// 宿舍考勤配置保存
export function saveSignConfig(data) {
  return axios({
    url: '/school/dormitory/saveSignConfig',
    method: 'POST',
    data: data,
  });
}

// 宿舍考勤配置修改状态
export function saveSignConfigState(data) {
  return axios({
    url: '/school/dormitory/saveSignConfigState',
    method: 'POST',
    data: data,
  });
}

// 删除宿舍量化考评明细
export function delRoomReportDetail(data) {
  return axios({
    url: '/school/report/delRoomReportDetail',
    method: 'POST',
    data: data,
  });
}

// 保存课堂签到时间
export function saveClassTime(data) {
  return axios({
    url: '/school/classTime/save',
    method: 'POST',
    data: data,
  });
}

// 删除启用禁用 课堂时间
export function updStatusClassTime(data) {
  return axios({
    url: '/school/classTime/updStatus',
    method: 'POST',
    data: data,
  });
}

// 保存设备绑定（蓝牙信标）
export function saveBeacon(data) {
  return axios({
    url: '/school/beacon/save',
    method: 'POST',
    data: data,
  });
}

// 删除 设备绑定（蓝牙信标）
export function delBeacon(data) {
  return axios({
    url: '/school/beacon/del',
    method: 'POST',
    data: data,
  });
}

// 医务室短信导出
export function infirmaryMessageExport(params) {
  return axios({
    url: '/school/schoolMessage/infirmaryMessageExport',
    method: 'GET',
    responseType: 'blob',
    params: params,
  });
}

// 保存学校迟到配置
export function saveAccessLate(data) {
  return axios({
    url: '/studentLate/saveAccessLate',
    method: 'POST',
    data: data,
  });
}

// 删除学校迟到配置
export function delAccessLate(data) {
  return axios({
    url: '/studentLate/delAccessLate',
    method: 'POST',
    data: data,
  });
}

// 学生迟到记录导出(school:studentLate:studentLateRecordExport)
export function studentLateRecordExport(params) {
  return axios({
    url: '/studentLate/studentLateRecordExport',
    method: 'GET',
    responseType: 'blob',
    params: params,
  });
}

// 门禁计划列表
export function accessControlPlanList(params) {
  return axios({
    url: '/accessControlPlan/list',
    method: 'GET',
    params: params,
  });
}

// 新增/修改门禁计划
export function saveAccessControlPlan(data) {
  return axios({
    url: '/accessControlPlan/save',
    method: 'POST',
    data: data,
  });
}

// 删除门禁计划
export function delAccessControlPlan(data) {
  return axios({
    url: '/accessControlPlan/del',
    method: 'POST',
    data: data,
  });
}

// ================================ 教师档案
// 获取教师档案类型列表
export function getTeacherArchivesTypeList(params) {
  return axios({
    url: '/teacherArchives/getList',
    method: 'GET',
    params: params,
  });
}

// 新增教师档案类型
export function addTeacherArchivesType(data) {
  return axios({
    url: '/teacherArchives/add',
    method: 'POST',
    data: data,
  });
}

// 修改教师档案类型
export function updateTeacherArchivesType(data) {
  return axios({
    url: '/teacherArchives/update',
    method: 'POST',
    data: data,
  });
}

// 删除教师档案类型
export function deleteTeacherArchivesType(data) {
  return axios({
    url: '/teacherArchives/delete',
    method: 'POST',
    data: data,
  });
}

// 分页查询教师档案
export function getTeacherArchivesList(params) {
  return axios({
    url: '/teacherArchives/getArchivesList',
    method: 'GET',
    params: params,
  });
}

// 新增教师档案
export function addTeacherArchives(data) {
  return axios({
    url: '/teacherArchives/addArchives',
    method: 'POST',
    data: data,
  });
}

// 设置档案编号
export function updateTeacherArchivesDocNum(data) {
  return axios({
    url: '/teacherArchives/updateArchivesDocNum',
    method: 'POST',
    data: data,
  });
}

// 删除教师档案
export function deleteTeacherArchives(data) {
  return axios({
    url: '/teacherArchives/deleteArchives',
    method: 'POST',
    data: data,
  });
}

// 归档教师档案
export function archivingTeacherArchives(data) {
  return axios({
    url: '/teacherArchives/archivingArchives',
    method: 'POST',
    data: data,
  });
}

// 查看或下载档案文件时记录日志
export function addTeacherArchivesLog(params) {
  return axios({
    url: '/teacherArchives/addArchivesLog',
    method: 'GET',
    params: params,
  });
}

// 审核教师档案
export function checkTeacherArchives(data) {
  return axios({
    url: '/teacherArchives/checkArchives',
    method: 'POST',
    data: data,
  });
}

// 分页查询教师档案日志
export function getTeacherArchivesLogList(params) {
  return axios({
    url: '/teacherArchives/getLogList',
    method: 'GET',
    params: params,
  });
}
